module.exports = __webpack_public_path__ + "media/anim3.74d0cda2.mp4";